import * as React from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
interface props {
  name?: string;
  breadCrumb?: string;
  isEditMode?: any;
  setisEditMode?: any;
  cancelEdit?: any;
}

const PageTitle = ({
  name,
  breadCrumb,
  isEditMode,
  setisEditMode,
  cancelEdit,
}: props) => {
  return (
    <div className="d-flex justify-content-between align-items-center pageTitle py-2">
      <div className="d-flex justify-content-xl-start justify-content-center align-items-center ps-lg-3 ps-md-5 ps-5">
        <h5 className="Title colorBlack font20 mb-0 me-2">{name}</h5>
        {breadCrumb !== "" ? <NavigateNextIcon className="me-2" /> : ""}
        <h5 className="colorBlack font20 mb-0">{breadCrumb}</h5>
      </div>
      {isEditMode === true ? (
        <button
          type="button"
          className="btn cancelBtn"
          onClick={cancelEdit}
        >
          Cancel
        </button>
      ) : (
        ""
      )}
    </div>
  );
};

export default PageTitle;
